import React from 'react';
import { Mail, Phone, MapPin, ExternalLink } from 'lucide-react';
import { Button } from './ui/button';
import { Separator } from './ui/separator';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_f78efe4f-09a5-4db6-b086-27b56377378d/artifacts/2ml4xhzv_sahi%20disha%20logo.jpeg';

export const SiteFooter = () => {
  return (
    <footer className="border-t border-border bg-background py-10 sm:py-14" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
          {/* Company */}
          <div>
            <div className="flex items-center justify-center sm:justify-start mb-4">
              <img src={LOGO_URL} alt="Sahi Disha Logo" className="h-20 sm:h-24 w-auto object-contain" />
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
              Navigating Your Wealth. We help Indian investors plan their financial future with 
              smart, inflation-adjusted strategies.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-primary mb-3">Contact Us</h4>
            <div className="space-y-3">
              <a
                href="mailto:info@sahidisha.in"
                className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary"
                style={{ transition: 'color 0.15s ease' }}
                data-testid="footer-email-link"
              >
                <Mail size={14} />
                info@sahidisha.in
              </a>
              <a
                href="tel:+919824050200"
                className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary"
                style={{ transition: 'color 0.15s ease' }}
                data-testid="footer-phone-link"
              >
                <Phone size={14} />
                +91 98240 50200
              </a>
              <div className="flex items-start gap-2 text-sm text-muted-foreground">
                <MapPin size={14} className="mt-0.5 shrink-0" />
                <span>
                  TF 301, S9 Imperial, Parpada Road corner, above Zudio, opposite Bihari Baug,
                  Abu Highway, Palanpur
                </span>
              </div>
            </div>
          </div>

          {/* Quick Actions */}
          <div>
            <h4 className="text-sm font-semibold text-primary mb-3">Quick Actions</h4>
            <div className="space-y-2">
              <Button
                className="w-full bg-accent text-accent-foreground hover:bg-accent/90 rounded-xl h-10 text-sm font-semibold active:scale-[0.98]"
                onClick={() => window.open('tel:+919824050200')}
                data-testid="footer-consult-expert-button"
                style={{ transition: 'background-color 0.2s ease, box-shadow 0.2s ease' }}
              >
                <Phone size={14} className="mr-2" />
                Consult an Expert
              </Button>
              <Button
                variant="outline"
                className="w-full rounded-xl h-10 text-sm border-border text-primary hover:bg-secondary"
                onClick={() => window.open('mailto:info@sahidisha.in')}
                style={{ transition: 'background-color 0.2s ease' }}
              >
                <Mail size={14} className="mr-2" />
                Send us an Email
              </Button>
            </div>
          </div>
        </div>

        <Separator className="my-6" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} Sahi Disha Financial Services Pvt. Ltd. All rights reserved.</p>
          <p>
            <span className="font-medium">Disclaimer:</span> This calculator is for illustrative purposes only and does not constitute financial advice.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
